import { ISkillItem } from "../../../../types"
import { IQuestionSkillItem } from "../../../editor/types"


export enum CHANGE_TYPE {
    Create = "create",
    Delete = "destroy",
    Update = "update",
    None = "none"
}

export default class ExamComparisonForm {
    public examId: number = 0
    public questionLog: QuestionForm[]
}

export class QuestionForm {
    public id: number | undefined
    public changeType: CHANGE_TYPE = CHANGE_TYPE.None
    public body: string 
    public explanation: string 
    public fieldType: string 
    public htmlBody: string 
    public group: number

    public answerItemsAttributes: AnswerForm[] = []
    public skills: SkillForm[] = []
}

export class AnswerForm {
    public id: number | undefined
    public changeType: CHANGE_TYPE = CHANGE_TYPE.None
    public body: string 
    public correct: boolean 
    public name: string 
    public allotment: number 
    public scopeId: number = 0;
}

export class SkillForm {
    public name: string
    public skillItems: IQuestionSkillItem[]
}

export const objToSkillForms = (obj: {[key: string]: IQuestionSkillItem[]}) : SkillForm[] => {
    const arr : SkillForm[] = []
    Object.keys(obj).forEach(name => {
        arr.push({
            name,
            skillItems: obj[name]
        })
    });
    return arr
}
